import { useEffect } from 'react';

import type { Dictionary } from '@/shared/legacy/contexts/LocalizationContext/types';

import { Language, useI18nStore } from './i18n.store';

/**
 * This is not a good practice, but it's the quickest way to sync the dictionary with the context without doing a complete refactor on i18n.
 *
 * Please avoid reproducing this pattern in new code.
 */
export const useSyncDictionaryWithContext = (dictionary: Dictionary, language: Language) => {
  const setDictionary = useI18nStore((s) => s.setDictionary);
  const setLanguage = useI18nStore((s) => s.setLanguage);

  useEffect(() => {
    setDictionary(dictionary);
  }, [dictionary, setDictionary]);

  useEffect(() => {
    setLanguage(language);
  }, [language, setLanguage]);
};
